import type { ReactNode } from 'react';

/** Uma coluna da fileira da barra do rent a car: o rótulo da pergunta em cima
 *  e o campo embaixo — a mesma anatomia da página do hotel. O rótulo é
 *  `aria-hidden` porque o nome acessível já sai do próprio campo. */
export function FieldColumn({
  label,
  field,
  children,
}: {
  readonly label: string;
  /** O que o CSS lê para dar largura à coluna (`rental_search_bar.css`). */
  readonly field: 'place' | 'dates';
  readonly children: ReactNode;
}): ReactNode {
  return (
    <div className="iuk-rental-search-field" data-field={field}>
      <span aria-hidden="true" className="iuk-rental-search-label">
        {label}
      </span>
      <div className="relative min-w-0">{children}</div>
    </div>
  );
}
